import * as React from 'react';
import {
    DigitalStylingImageProcessingTabPanel,
    DigitalStylingImageProcessingTabPanelLabels
} from './DigitalStylingImageProcessingTabPanel';

type DigitalStylingOrderAdminViewLabels = {
    // ...
} & DigitalStylingImageProcessingTabPanelLabels;

type DigitalStylingOrderAdminViewProps = {
    labels: DigitalStylingOrderAdminViewLabels;
    orderId: number;
};

export function DigitalStylingOrderAdminView({
    labels,
    orderId
}: DigitalStylingOrderAdminViewProps) {
    return (
        <fieldset>
            <DigitalStylingImageProcessingTabPanel labels={labels} orderId={orderId} />
        </fieldset>
    );
}
